import { Box, Button } from '@mui/material';
import { trackAmplitudeEvent } from '@/lib/analyticsHelper';
import { useHeroContent } from './HeroContentContext';

const JobHeroCTA = () => {
  const { enrollmentURL } = useHeroContent();

  const handleJoinFreeBtn = () => {
    const amplitudeData = {
      cta_text: 'Join free to get started',
      cta_type: 'button',
    };

    trackAmplitudeEvent('CTA Interacted', amplitudeData);
  };

  return (
    <Box display="flex" flexDirection="column" maxWidth={{ xs: '100%', sm: '360px' }}>
      <Button
        sx={{
          width: '100%',
        }}
        href={enrollmentURL}
        color="primary"
        variant="contained"
        component="a"
        onClick={handleJoinFreeBtn}
        size="large"
        rel="nofollow">
        Join free to get started
      </Button>
    </Box>
  );
};

export default JobHeroCTA;
